import { createNamespacedHelpers } from 'vuex'
import { PERFORMANCE } from '../interface/performance'
import { merge } from 'lodash'

const initState = {
  performance: {},
}

const mutations = {
  [PERFORMANCE.PERFORMANCE](state, paylod) {
    state.performance = merge(state.performance, paylod)
    console.log(state.performance)
  },
  [PERFORMANCE.CLEAR](state) {
    state.performance = {}
  },
}

const { mapMutations, mapState } = createNamespacedHelpers('performance')

export { mapMutations, mapState, PERFORMANCE }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
}
